import { Component, ViewChild,Input, OnInit } from '@angular/core';
/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';

/*Services*/
import { ShareDeviceService, ObservableObjectsService } from "@services"

import { Device, ShareRequest, ObservableObject } from '@models';

import { ObjectsService } from '@services/http/objects.service';

import { CachedDataService, AppService } from '@services';

import { CONFIG } from '../../../config';
declare var swal: any;

@Component({
  selector: 'app-share-device-confirm-modal',
  templateUrl: './share-device-confirm-modal.component.html'
})

export class ShareDeviceConfirmModalComponent implements OnInit {

  @ViewChild('shareDeviceModal') shareDeviceModal: BsModalComponent;
  currentRequest: ShareRequest;
  errorMessage: string;
  newObjectNameModal: string;
  typeAddModel = "new";
  trySubmit = false;
  extraType = CONFIG.extra;
  observableObjectIdModel;
  btnText: any = {
    text: 'Подвердить',
    defaultText: 'Подвердить',
    loadText: 'Подверждение..'
  };

  observableObjects: ObservableObject[];

  constructor(private shareDeviceService: ShareDeviceService, private objectsService: ObjectsService, private cachedDataService: CachedDataService, private observableObjectsService: ObservableObjectsService, private appService: AppService){}


  ngOnInit(){

    if(!this.cachedDataService.isAuth())
      return;

	this.getObservableObjects()
  }
  initForm(){
    this.newObjectNameModal = null;
	this.typeAddModel = "new";
	this.observableObjectIdModel = null
  }

  onChangeType(){
    console.log(this.typeAddModel)
  }

	submit(){
		this.trySubmit = true;
		if(this.typeAddModel === "new"){
			if(!this.newObjectNameModal || !this.newObjectNameModal.length){
				return false;
			}
			this.createNewObject()
		}else{
			this.addDeviceToObject(this.observableObjectIdModel)
		}
		this.btnText.text = this.btnText.loadText;
		this.errorMessage = null;
	}

	createNewObject(){
		this.objectsService.addObject(
			this.newObjectNameModal,
			'Transport',
			this.extraType.car,
			this.cachedDataService.currentUserId)
				.subscribe(response => {
					console.log(response)
					this.addDeviceToObject(response.id)
				},
				error => {
					this.btnText.text = this.btnText.defaultText;
					let errorMessage = 'Ошибка, повторите позже';
					if (error.error && error.error.errorMessage) {
						errorMessage = error.error.errorMessage;
					}
					this.errorMessage = errorMessage;
					this.trySubmit = false;
					this.btnText.text = this.btnText.defaultText;
				}
			);
	}

	addDeviceToObject(objectId?){
		this.shareDeviceService.confirmShareDevice(this.currentRequest.deviceId, this.currentRequest.slaveUserId,"confirmed",null, objectId ? objectId : "test" )
		.subscribe(response => {
				this.shareDeviceService.updateRequestsSubject.next(null)
				this.btnText.text = this.btnText.defaultText;
				this.trySubmit  = false;
				this.btnText.text = this.btnText.defaultText;

				swal({
					type: 'success',
					text: 'Устройство добавлено',
					showConfirmButton: false,
					timer: 3000,
				});
				this.getObservableObjects()
				this.close();
			},
			error => {
				this.btnText.text = this.btnText.defaultText;
				let errorMessage = 'Ошибка, повторите позже';
				if (error.error && error.error.errorMessage) {
					errorMessage = error.error.errorMessage;
				}
				this.errorMessage = errorMessage;
				this.trySubmit = false;
				this.btnText.text = this.btnText.defaultText;
			}
		);
	}


	getObservableObjects(){

		this.observableObjectsService.getAll()
			.subscribe(response => {
				if(response && response.length){
					this.observableObjects = this.appService.filterObjects(response);
					this.cachedDataService.setObservableObjects(this.observableObjects);
					this.observableObjects = this.cachedDataService.getObservableObjects();
				}else{
					this.observableObjects = null;
				}

			}, error =>{
				console.log('from component error', error)
			});

	  }

  	open(request: ShareRequest) {
		this.initForm();
		this.currentRequest = request;
		this.shareDeviceModal.open();
	}

	close() {
		this.shareDeviceModal.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/view/modal/share-device-confirm-modal/share-device-confirm-modal.component.ts